// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CYdA","content":"styles_content__3Qoqv"};